import Api from "./Api";

function CreateProcess(token,data,cancelToken){
    const response=Api.post('/api/v1/Providers/TosanBillPayment/CreateProcess',data,{
        headers:{
            "Authorization": `Bearer ${token}`,
            cancelToken
        }
    });

    return response;

}
export default CreateProcess